<template>
    <div class="wrapper">
        <DataTable :value="logRows">
          <Column field="userId" header="Chaufför" :sortable="true"></Column>
          <Column field="truckId" header="På lastbil" :sortable="true"></Column>
          <Column field="currPlaceId" header="Nuvarande plats" :sortable="true"></Column>
          <Column field="prevFillPlaceId" header="Föregående plats" :sortable="true"></Column>
          <Column field="fractionId" header="Fraktion" :sortable="true"></Column>
          <Column field="wash" header="Tvätt" headerStyle="width:5rem" bodyStyle="text-align:center" :sortable="true">
               <template #body="slotProps">
                 <Checkbox v-model="slotProps.data.wash" :binary="true" />
              </template>
            </Column>
          <Column field="comment" header="Kommentar" :sortable="true"></Column>
          <Column header="Datum" :sortable="true">
            <template #body="slotProps" >
              {{getDate(slotProps.data.createdAt)}}
            </template>
          </Column>
        </DataTable>
    </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import moment from 'moment'
import Checkbox from 'primevue/checkbox'
export default {
  components: {
    DataTable,
    Column,
    moment,
    Checkbox
  },
  props: {
    containerId: ''
  },
  watch: {
    containerId: function (newVal, oldVal) {
      this.$props.containerId = newVal
    }
  },
  data () {
    return {
      logRows: []
    }
  },
  async mounted () {
    this.logRows = await this.getLogRows()
  },
  methods: {
    async getLogRows () {
      let response = await this.$http.get('/api/containerlog/bycontainerforcontainerpositions/' + this.$props.containerId)
      return response.data
    },
    getDate (theDate) {
      let formattedDate = moment(theDate).utc().format('YYYY-MM-DD HH:mm:ss')
      return formattedDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Activities/ContainerLogByContainer.vue